import React, { FC, useEffect } from 'react';
import { useLocale } from '../../contexts/localeContext';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import Label from '../label/label';
import { Field, useFormikContext } from 'formik';
import Togglebox from '../togglebox/togglebox';
import { validateItemLength } from '../../utilities/Validation';

export const SiteDetails: FC = () => {
    const { errors, values, setFieldValue } = useFormikContext<any>();
    const { translate } = useLocale();
    const hexValues = /\d|[a-fA-F]/

    const restrictLength = (e, length) => {
        if (e.key !== 'Backspace'
            && e.key !== 'Tab'
            && (!e.key.match(hexValues)
                || e.target.value.length === length
                || e.target.value.length > length)) {
            e.preventDefault();
            
        }
    }

    useEffect(() => {
        if (!values.tagmask) setFieldValue('tagmask', 'FFFFFFFFFFFFF')
    }, [])

    return <><div>
        <div className="flex flex-row">

            <div className="flex flex-col flex-1 pr-3" id='tagMaskLabel'>
                <Label htmlFor='tagmask'
                    className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.tagmask)}:</Label>
                <Field name="tagmask" id='tagMaskInputfield'
                    type="text"
                    className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-800 text-sm bg-gray-input w-full"
                    onKeyDown={e => restrictLength(e, 13)}
                    onPaste={(e)=>{ e.preventDefault();}} 
                    validate={val => validateItemLength(val, 13, translate)}>
                </Field>
                {errors.tagmask ? <span className='text-red-600 text-xs'>{errors.tagmask}</span> : null}
            </div>

            <div className="flex flex-col flex-1 pl-3">
                <Label htmlFor='tagmaskRemovezeros'
                    className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.tagmaskRemovezeros)}:</Label>
                <Togglebox name="tagmaskRemovezeros" label={''} />
            </div>
        </div>

    </div></>;
};
